import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../SimpleForm/UI/Button";
import useModal from "../../Hooks/useModal";
import {
  createNewGroup,
  resetCreateGroupState,
} from "../actions/action_createGroup";
import { fetchUserData } from "../../../global/app/actions/actions_fetchUsers";
import "./CreateGroupView.scss";

const CreateGroupView = () => {
  const dispatch = useDispatch();
  const { toggleModal, setModalOpen } = useModal();
  const currentUser = useSelector(
    (state) => state.appReducer.userDataReducer.data
  );
  const { data, error, loading, initial } = useSelector(
    (state) => state.createGroupReducer
  );

  const createGroup = () => {
    dispatch(createNewGroup(currentUser));
  };

  const callbacks = { createGroup };

  useEffect(() => {
    if ((!!data || !!error) && !loading && !initial) {
      setModalOpen(false);
      if (!!data && !error) dispatch(fetchUserData());
      dispatch(resetCreateGroupState());
    }
  }, [data, error, loading, initial]);

  return (
    <>
      <div className="header-container">
        <div className="header-content">
          <div className="grid-row">
            <div className="usa-header-profile grid-col-10">
              <h3 className="usa-flag-page-header">Create Network</h3>
              <p className="headerInfo">
                Link yourself to a network where you can share cases and
                profiles across accounts
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="create-group-container">
        <h3 className="header-text">Create a Network</h3>
        <p className="create-group-text">
          Networks are used to share cases and profiles with others within your
          organization. Click the button below to create a new network.
        </p>
        <Button
          onClick={() =>
            toggleModal("createGroupModal", "content", null, callbacks)
          }
        >
          Create Network
        </Button>
      </div>
    </>
  );
};

export default CreateGroupView;
